import { render } from "./elem-price.vue?vue&type=template&id=20d252a7&ts=true"
import script from "./elem-price.vue?vue&type=script&lang=ts"
export * from "./elem-price.vue?vue&type=script&lang=ts"

import "./elem-price.vue?vue&type=style&index=0&id=20d252a7&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__